import {
  FormFieldSchema,
  FormFieldType,
} from "@app/components/forms/types/schema";

export const accountSchema: FormFieldSchema[] = [
  {
    id: "account",
    noneStyle: true,
    type: FormFieldType.Group,
    schemas: [
      {
        id: "account",
        label: "회원 정보",
        noneStyle: true,
        type: FormFieldType.Group,
        schemas: [
          {
            id: "email",
            label: "회원 아이디",
            placeholder: "아이디를 입력해주세요.",
            type: FormFieldType.Text,
            behavior: {
              disabled: true,
            },
          },
          {
            id: "name",
            label: "회원 이름",
            placeholder: "이름을 입력해주세요.",
            type: FormFieldType.Text,
            behavior: {
              disabled: true,
            },
          }
        ]
      }
    ],
  },
  { type: FormFieldType.Separator },
];
